import { Api } from 'api/Api';
import { createAction } from 'utils/helpers';
import { updateResWithRadioBtn } from 'utils/inputFormUtil';
// import { PHOENIX_SERVICES } from 'containers/phoenix/data/PhoenixServiceList';
import { TIMEPERIOD_TIMESERIES_IO_DATA } from 'containers/phoenix/data/PhoenixServiceIO';
import { updatePhoenixToken } from 'containers/phoenix/redux/PhoenixActions';
import { phoenixSignIn } from 'utils/excelUtils/office-apis-helpers';
import { CreateNewDataConst } from './CreateNewDatasetConst';
import { reset_all_data } from '../phoenix/redux/PhoenixActions';
// import { PhoenixAuthService } from '../auth/PhoenixAuthService';

const {
	FETCH_SERVICE_BEGIN,
	FETCH_SERVICE_SUCCESS,
	FETCH_SERVICE_FAILURE,
	FETCH_CREATE_DATA_SUCCESS,
	FETCH_CREATE_DATA_FAILURE,
	BACK_BUTTON_CLICKED,
	NEW_SERVICE_SELECTED,
	UPDATE_NODE_DATA,
	NEW_GET_DATA_BEGIN,
	SELECTED_DATASET,
	UPDATE_SELECTED_DATASET,
} = CreateNewDataConst;

export const onBackClick = () => dispatch => {
	dispatch(createAction(BACK_BUTTON_CLICKED));
};

// on service selection below method getting called and dispatch data to store
export const onServiceClick = (selectedSerivceObj, history, token) => {
	// Helper to handle Phoenix login success logic
	const handlePhoenixLoginSuccess = (
		dispatch,
		history,
		selectedSerivceObj,
		access_token,
	) => {
		// localStorage.setItem('phoenix_auth_token', access_token);
		const data = TIMEPERIOD_TIMESERIES_IO_DATA;
		dispatch(
			createAction(NEW_SERVICE_SELECTED, {
				selectedSerivceObj,
			}),
		);
		if (history.location.pathname === '/create-new-dataset') {
			dispatch(createAction('INITIAL_STATE'));
			dispatch(createAction(FETCH_SERVICE_SUCCESS, data));
			dispatch(reset_all_data());
		}
		dispatch(updatePhoenixToken(access_token));
		history.push('/input-form');
	};

	return async dispatch => {
		const {
			servicename,
			serviceMetaDataPath,
			displayOrientation,
			valuationFrequency,
			serviceId,
		} = selectedSerivceObj;
		dispatch(createAction(FETCH_SERVICE_BEGIN));
		dispatch(createAction(NEW_GET_DATA_BEGIN));
		if (
			serviceId === 'PhoenixTimePeriod' ||
			serviceId === 'PhoenixTimeSeries'
		) {
			// Open Office dialog for Phoenix IAM authentication
			// const port = window.location.port ? `:${window.location.port}` : '';
			// const ts = Date.now();
			// const dialogUrl = `${window.location.protocol}//${window.location.hostname}${port}/#/phoenix?ts=${ts}`; // or your Phoenix auth route
			if (token == null || token === undefined || token === '') {
				phoenixSignIn(
					dispatch,
					history,
					selectedSerivceObj,
					handlePhoenixLoginSuccess,
				);
			} else {
				handlePhoenixLoginSuccess(
					dispatch,
					history,
					selectedSerivceObj,
					token,
				);
			}
			return;
		}
		return Api.retriveServiceData(serviceMetaDataPath, servicename)
			.then(res => {
				let { data } = res;
				if (displayOrientation || valuationFrequency) {
					data = updateResWithRadioBtn(
						data,
						selectedSerivceObj,
						true,
					);
				}
				dispatch(
					createAction(NEW_SERVICE_SELECTED, {
						selectedSerivceObj,
					}),
				);
				dispatch(createAction('INITIAL_STATE'));
				dispatch(createAction(FETCH_SERVICE_SUCCESS, data));
				history.push('/input-form');
				return data;
			})
			.catch(error =>
				dispatch(createAction(FETCH_SERVICE_FAILURE, error)),
			);
	};
};

// below method getting called on create new dataset on load and dispatch data to store
export function createNewDatasetValue() {
	return dispatch => {
		dispatch(createAction(FETCH_SERVICE_BEGIN));
		// const json = {data : {lstProductData : [PHOENIX_SERVICES]}};
		// dispatch(createAction(FETCH_CREATE_DATA_SUCCESS, json.data));
		// return json.data;
		return Api.retriveServiceList()
			.then(json => {
				// json.data?.lstProductData?.push(PHOENIX_SERVICES);
				dispatch(createAction(FETCH_CREATE_DATA_SUCCESS, json.data));
				return json.data;
			})
			.catch(error =>
				dispatch(createAction(FETCH_CREATE_DATA_FAILURE, error)),
			);
	};
}

export function updateNodeData(nodeData) {
	return dispatch => {
		dispatch(createAction(UPDATE_NODE_DATA, nodeData));
	};
}
export function updateSelectedDataset(nodeData) {
	return dispatch => {
		dispatch(createAction(UPDATE_SELECTED_DATASET, nodeData));
	};
}
export function onDatasetSelect(nodeData) {
	return dispatch => {
		if (
			nodeData?.serviceData.serviceId === 'PhoenixTimePeriod' ||
			nodeData?.serviceData.serviceId === 'PhoenixTimeSeries'
		) {
			dispatch(createAction('SELECTED_PHOENIX_DATASET', nodeData));
		} else {
			dispatch(createAction(SELECTED_DATASET, nodeData));
		}
	};
}
